import * as cn from "classnames";
import * as React from "react";
import "./DashboardFilters.css";
import { SvgIcon } from "./SvgIcon";
import { Triangle } from "@icons";

const mockStatusData = [
    { name: "Draft", reqUrl: "draft", theme: "checkmark-theme-draft" },
    { name: "Pending", reqUrl: "pending", theme: "checkmark-theme-pending" },
    { name: "Approved", reqUrl: "approved", theme: "checkmark-theme-approved" },
    { name: "Review", reqUrl: "review", theme: "checkmark-theme-review" },
    { name: "Running", reqUrl: "running", theme: "checkmark-theme-running" },
    { name: "Paused", reqUrl: "paused", theme: "checkmark-theme-paused" },
    { name: "Suspended", reqUrl: "suspended", theme: "checkmark-theme-suspended" },
    { name: "Completed", reqUrl: "completed", theme: "checkmark-theme-completed" },
    { name: "Archived", reqUrl: "archived", theme: "checkmark-theme-archived" }
];

export interface FiltersInterface {
    draft: boolean;
    ready: boolean;
    pending: boolean;
    running: boolean;
    suspended: boolean;
    requiringCallToSupport: boolean;
    archived: boolean;
}

export interface DashboardFiltersComponentProps {
    filters: FiltersInterface;
    onFilter: (filters: string[]) => void;
    onLinkToNewCampaignPage: () => void;
}

export class DashboardFiltersComponent extends React.Component<DashboardFiltersComponentProps, any> {
    constructor(props: DashboardFiltersComponentProps) {
        super(props);
        this.state = {
            filters: {
                draft: this.props.filters.draft,
                ready: this.props.filters.ready,
                pending: this.props.filters.pending,
                running: this.props.filters.running,
                suspended: this.props.filters.suspended,
                requiringCallToSupport: this.props.filters.requiringCallToSupport,
                archived: this.props.filters.archived
            },
            isFiltersOpen: false
        };
    }

    componentDidUpdate(prevProps: DashboardFiltersComponentProps) {
        if (this.props.filters !== prevProps.filters) {
            this.setState({
                ...this.state,
                filters: this.props.filters
            });
        }
    }

    async toogleFilter(e: any, filterName: string) {
        e.preventDefault();

        if (filterName === "all") {
            await this.setState({
                ...this.state,
                filters: {
                    draft: false,
                    pending: false,
                    approved: false,
                    review: false,
                    running: false,
                    paused: false,
                    suspended: false,
                    completed: false,
                    archived: false
                }
            });
        } else {
            await this.setState({
                ...this.state,
                filters: {
                    ...this.state.filters,
                    [filterName]: !this.state.filters[filterName]
                }
            });
        }

        (() => this.handleFilterChange())();
    }

    handleFilterChange() {
        const filters = this.state.filters;
        const sortMass: string[] = [];
        for (let key in filters) {
            if (filters[key] === true) sortMass.push(key);
        }

        this.props.onFilter(sortMass);
    }

    toogleFiltersPopup(isFiltersOpen?: boolean) {
        this.setState({
            ...this.state,
            isFiltersOpen: isFiltersOpen ? isFiltersOpen : !this.state.isFiltersOpen
        });
    }

    render() {
        const { filters, isFiltersOpen } = this.state;
        const { onLinkToNewCampaignPage } = this.props;
        const isActiveAllBtn: boolean = Object.keys(filters)
            .map(k => filters[k])
            .some(f => f === true);

        return (
            <div className="filters-wrapper">
                <div style={{ marginBottom: "1rem" }}>
                    <span
                        className={cn("filters__text-btn", isActiveAllBtn ? "" : "filters__text-btn_disabled")}
                        onClick={e => this.toogleFilter(e, `all`)}
                    >
                        Clear filters
                    </span>
                    <button
                        className="common-btn custom-filters-popup-btn"
                        type="button"
                        value="Filters"
                        onClick={e => this.toogleFiltersPopup()}
                    >
                        Filters{" "}
                        <SvgIcon
                            svg={Triangle}
                            className={cn("filters-popup-triangle", isFiltersOpen ? "active" : "")}
                        />
                    </button>
                    <button
                        className="common-btn dashboard-filters__add-campaign-btn tour-dashboard-add-campaign-button"
                        onClick={() => onLinkToNewCampaignPage()}
                    >
                        New Campaign
                    </button>
                </div>
                <div className={cn("filters-popup", isFiltersOpen ? "open" : "")}>
                    <h4>
                        Select filters <span className="close-btn" onClick={e => this.toogleFiltersPopup()} />
                    </h4>
                    <ul className="dashboard-filters-checkboxes">
                        {mockStatusData.map((el, index) => {
                            return (
                                <li key={index}>
                                    <label
                                        className={cn(
                                            "common-checkbox custom-dashboard-checkbox",
                                            filters[el.reqUrl] ? "active" : ""
                                        )}
                                        onClick={e => this.toogleFilter(e, `${el.reqUrl}`)}
                                    >
                                        <input type="checkbox" />
                                        {el.name}
                                        <span className={cn("checkmark", el.theme ? el.theme : "")} />
                                    </label>
                                </li>
                            );
                        })}
                    </ul>
                </div>
                <div className="active-filters-block">
                    {mockStatusData.filter(el => (filters[el.reqUrl] ? true : false)).map((el, index: number) => {
                        return (
                            <span
                                className="active-filter-tag"
                                key={index}
                                onClick={e => this.toogleFilter(e, `${el.reqUrl}`)}
                            >
                                <span
                                    className={cn(
                                        "status-circles filters-custom-status-circles",
                                        el.reqUrl + "-circle"
                                    )}
                                />
                                {el.name}
                                <span className="deactivate-btn" />
                            </span>
                        );
                    })}
                </div>
            </div>
        );
    }
}
